import { render, staticRenderFns } from "./ManagerDistributions.vue?vue&type=template&id=6fd5c73b&"
import script from "./ManagerDistributions.vue?vue&type=script&lang=js&"
export * from "./ManagerDistributions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports